import {
  SHIFT_CLASS_LIST, SHIFT_CLASS_LIST_SUCCESS, SHIFT_CLASS_LIST_FAILURE,
  SHIFT_CLASS_CREATE, SHIFT_CLASS_CREATE_SUCCESS, SHIFT_CLASS_CREATE_FAILURE,
  SHIFT_CLASS_UPDATE, SHIFT_CLASS_UPDATE_SUCCESS, SHIFT_CLASS_UPDATE_FAILURE,
  SHIFT_CLASS_DELETE, SHIFT_CLASS_DELETE_SUCCESS, SHIFT_CLASS_DELETE_FAILURE
} from './mutation-types'

export default {
  state: {
    shiftClassHayaHoList: [],
    shiftClassHayaKaList: [],
    shiftClassNakaHoList: [],
    shiftClassOsoHoList: [],
    shiftClassOsoKaList: [],
    shiftClassKyukaList: [],
    shiftClassSonotaList: []
  },
  getters: {
    shiftClassHayaHoList: state => {
      return state.shiftClassHayaHoList
    },
    shiftClassHayaKaList: state => {
      return state.shiftClassHayaKaList
    },
    shiftClassNakaHoList: state => {
      return state.shiftClassNakaHoList
    },
    shiftClassOsoHoList: state => {
      return state.shiftClassOsoHoList
    },
    shiftClassOsoKaList: state => {
      return state.shiftClassOsoKaList
    },
    shiftClassKyukaList: state => {
      return state.shiftClassKyukaList
    },
    shiftClassSonotaList: state => {
      return state.shiftClassSonotaList
    }
  },
  actions: {
    [SHIFT_CLASS_LIST] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/master/shift_classes', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CLASS_LIST_FAILURE, res.data)
          } else {
            commit(SHIFT_CLASS_LIST_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CLASS_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/shift_classes', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHIFT_CLASS_CREATE_FAILURE, res.data)
            } else {
              commit(SHIFT_CLASS_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [SHIFT_CLASS_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/shift_classes/' + params.id, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHIFT_CLASS_UPDATE_FAILURE, res.data)
            } else {
              commit(SHIFT_CLASS_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [SHIFT_CLASS_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('SHIFT_CLASS_DELETE:' + params.id)
      var data = params.data
      var url = '/master/shift_classes/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CLASS_DELETE_FAILURE, res.data)
          } else {
            commit(SHIFT_CLASS_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHIFT_CLASS_LIST_FAILURE] (state, data) {
      console.log('SHIFT_CLASS_LIST_FAILURE')
    },
    [SHIFT_CLASS_LIST_SUCCESS] (state, data) {
      console.log('SHIFT_CLASS_LIST_SUCCESS')
      state.shiftClassHayaHoList = data.data.haya_ho.data
      state.shiftClassHayaKaList = data.data.haya_ka.data
      state.shiftClassNakaHoList = data.data.naka_ho.data
      state.shiftClassOsoHoList = data.data.oso_ho.data
      state.shiftClassOsoKaList = data.data.oso_ka.data
      state.shiftClassKyukaList = data.data.kyuka.data
      state.shiftClassSonotaList = data.data.sonota.data
      if (data.callback) {
        data.callback()
      }
    },
    [SHIFT_CLASS_CREATE_FAILURE] (state, data) {
      console.log('SHIFT_CLASS_CREATE_FAILURE')
    },
    [SHIFT_CLASS_CREATE_SUCCESS] (state, data) {
      console.log('SHIFT_CLASS_CREATE_SUCCESS')
      var callback = data.callback
      callback()
    },
    [SHIFT_CLASS_UPDATE_FAILURE] (state, data) {
      console.log('SHIFT_CLASS_UPDATE_FAILURE')
    },
    [SHIFT_CLASS_UPDATE_SUCCESS] (state, data) {
      console.log('SHIFT_CLASS_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    },
    [SHIFT_CLASS_DELETE_FAILURE] (state, data) {
      console.log('SHIFT_CLASS_DELETE_FAILURE')
    },
    [SHIFT_CLASS_DELETE_SUCCESS] (state, data) {
      console.log('SHIFT_CLASS_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-class.js